import React, { useEffect, useRef, useState } from 'react';
import { Segment, Tabs } from 'tea-component';
import { debounce } from 'lodash-es';
import { debounce as throttleDebounce } from 'throttle-debounce';
import { handleContentScroll } from '../../pages/accounts/utils';
import './index.scss';

export default function Navigator({
  options = [],
  value = '',
  onChange,
  scrollBody,
  fixNavigatorShow = true,
}: any) {
  const [curValue, setCurValue] = useState(value);
  const [segmentFixed, setSegmentFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const scrollTop = e?.srcElement?.scrollTop;
        // console.log(scrollTop);
        // 滚动判断 280 和定位条位置相关，开发调整
        if (scrollTop > 280) {
          setSegmentFixed(true);
        } else {
          setSegmentFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () =>
        scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  useEffect(() => {
    setCurValue(value);
  }, [value]);

  return (
    <>
      <Segment
        style={{ display: fixNavigatorShow ? 'inline-block' : 'none' }}
        className="dbo-accounts-segment segment-light "
        value={curValue?.toString()}
        onChange={(value) => {
          setCurValue(value);
          onChange?.(value);
        }}
        options={options}
      />
      <Segment
        className={`dbo-accounts-header-segment header-segment ${
          segmentFixed ? 'visible' : 'hide'
        }`}
        value={curValue?.toString()}
        onChange={(value) => {
          setCurValue(value);
          onChange?.(value);
        }}
        options={options}
      />
    </>
  );
}

export function TabNavigator({
  options = [],
  value = '',
  onChange,
  scrollBody,
  fixNavigatorShow = true,
  scrollTopHeight = 280,
}: any) {
  const [curValue, setCurValue] = useState(value);
  const [segmentFixed, setSegmentFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const scrollTop = e?.srcElement?.scrollTop;
        // console.log(scrollTop);
        // 滚动判断 280 和定位条位置相关，开发调整
        if (scrollTop > scrollTopHeight) {
          setSegmentFixed(true);
        } else {
          setSegmentFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () =>
        scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  useEffect(() => {
    setCurValue(value);
  }, [value]);

  return (
    <>
      <Tabs
        tabs={options}
        className="dbo-accounts-tabs"
        // style={{ display: fixNavigatorShow ? 'inline-block' : 'none' }}
        // className="dbo-accounts-segment segment-light "
        activeId={curValue}
        onActive={(value) => {
          setCurValue(value.id);
          onChange?.(value.id);
        }}
      ></Tabs>
      <Tabs
        tabs={options}
        className={`dbo-accounts-tabs header-segment ${
          segmentFixed ? 'visible' : 'hide'
        }`}
        activeId={curValue}
        onActive={(value) => {
          setCurValue(value.id);
          onChange?.(value.id);
        }}
      ></Tabs>
    </>
  );
}

export function useNavigatorScroll({
  defaultValue = '',
  debounceTime = 100,
  allKeys,
  watchAllKeys = false,
  refBody = null,
}: {
  defaultValue?: string;
  debounceTime?: number;
  allKeys: Array<string>;
  watchAllKeys?: boolean;
  refBody?: any;
}) {
  const scrollBody = useRef<HTMLDivElement>(refBody);

  const [selectNavigator, setSelectNavigator] = useState(defaultValue);

  const handleScroll = throttleDebounce(debounceTime, () => {
    setSelectNavigator(
      handleContentScroll(selectNavigator, allKeys, scrollBody),
    );
  });

  useEffect(() => {
    if (watchAllKeys) {
      setSelectNavigator(allKeys[0]);
    }
  }, [allKeys]);

  return { selectNavigator, setSelectNavigator, handleScroll, scrollBody };
}
